module.exports = __webpack_public_path__ + "e-learning-app/static/img/2.7fbe981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 1